import Vue from 'vue'
import VueRouter from 'vue-router'
import homeRouter from '@/router/homeRouter'

Vue.use(VueRouter)
const routes = [
    ...homeRouter
]
const router = new VueRouter({
    routes,
    //解决跳转没有置顶的问题
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
})
export default router
